import React, { useRef } from 'react';
import { useInView } from 'framer-motion';
import './../styles/TextAnimate.css'
const TextAnimate = ({direction,children})=>{
    const ref = useRef(null)
    const isInView = useInView(ref,{once:true})
   /* console.log("isInView: ",isInView)*/
    return(
        <p className='Animated-label' ref={ref}  style={{
            transform: isInView ? "none" : direction === "toTop" ? "translateY(50%)" :"translateX(-20%)",
            opacity: isInView ? 1 : 0,
            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.4s"
          }}>

            {children}
          </p>
    )

}
export default TextAnimate;